import firebase from 'firebase';

const firebaseConfig = {
  apiKey: 'AIzaSyB9PdGHFrvgeuta6YXSPFl2eKqdhm-Wtxs',
  authDomain: 'slack-clone-c198d.firebaseapp.com',
  databaseURL: 'https://slack-clone-c198d.firebaseio.com',
  projectId: 'slack-clone-c198d',
  storageBucket: 'slack-clone-c198d.appspot.com',
  messagingSenderId: '35368981424',
  appId: '1:35368981424:web:81e0c63bc73cbcae2e7c75',
  measurementId: 'G-RXMQS6BBB2',
};

// This connects the entire App from front-end to back-end
const firebaseApp = firebase.initializeApp(firebaseConfig);

// This let us get access to our data base
const db = firebaseApp.firestore();

// This prepare authentication module (login inclusive) and the provider for authentication which in this case is GOOGLE.
const auth = firebase.auth();
const provider = new firebase.auth.GoogleAuthProvider();

export { auth, provider };
export default db;
